/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetProductsAsGroupName200ResponseDataInnerData } from './GetProductsAsGroupName200ResponseDataInnerData'
import {
  GetProductsAsGroupName200ResponseDataInnerDataFromJSON,
  GetProductsAsGroupName200ResponseDataInnerDataFromJSONTyped,
  GetProductsAsGroupName200ResponseDataInnerDataToJSON,
} from './GetProductsAsGroupName200ResponseDataInnerData'

/**
 *
 * @export
 * @interface GetProductsAsGroupName200ResponseDataInner
 */
export interface GetProductsAsGroupName200ResponseDataInner {
  /**
   *
   * @type {number}
   * @memberof GetProductsAsGroupName200ResponseDataInner
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof GetProductsAsGroupName200ResponseDataInner
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof GetProductsAsGroupName200ResponseDataInner
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof GetProductsAsGroupName200ResponseDataInner
   */
  description?: string | null
  /**
   *
   * @type {GetProductsAsGroupName200ResponseDataInnerData}
   * @memberof GetProductsAsGroupName200ResponseDataInner
   */
  data?: GetProductsAsGroupName200ResponseDataInnerData
  /**
   *
   * @type {number}
   * @memberof GetProductsAsGroupName200ResponseDataInner
   */
  price: number
  /**
   * Цена с применённой скидкой
   * @type {number}
   * @memberof GetProductsAsGroupName200ResponseDataInner
   */
  finalPrice: number
  /**
   *
   * @type {string}
   * @memberof GetProductsAsGroupName200ResponseDataInner
   */
  currenciesName?: string
  /**
   *
   * @type {number}
   * @memberof GetProductsAsGroupName200ResponseDataInner
   */
  currenciesNumber?: number
  /**
   *
   * @type {number}
   * @memberof GetProductsAsGroupName200ResponseDataInner
   */
  currenciesRatio?: number
  /**
   *
   * @type {string}
   * @memberof GetProductsAsGroupName200ResponseDataInner
   */
  currenciesTitle?: string
}

/**
 * Check if a given object implements the GetProductsAsGroupName200ResponseDataInner interface.
 */
export function instanceOfGetProductsAsGroupName200ResponseDataInner(
  value: object
): value is GetProductsAsGroupName200ResponseDataInner {
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('title' in value) || value['title'] === undefined) return false
  if (!('price' in value) || value['price'] === undefined) return false
  if (!('finalPrice' in value) || value['finalPrice'] === undefined)
    return false
  return true
}

export function GetProductsAsGroupName200ResponseDataInnerFromJSON(
  json: any
): GetProductsAsGroupName200ResponseDataInner {
  return GetProductsAsGroupName200ResponseDataInnerFromJSONTyped(json, false)
}

export function GetProductsAsGroupName200ResponseDataInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetProductsAsGroupName200ResponseDataInner {
  if (json == null) {
    return json
  }
  return {
    id: json['id'],
    name: json['name'],
    title: json['title'],
    description: json['description'] == null ? undefined : json['description'],
    data:
      json['data'] == null
        ? undefined
        : GetProductsAsGroupName200ResponseDataInnerDataFromJSON(json['data']),
    price: json['price'],
    finalPrice: json['finalPrice'],
    currenciesName:
      json['currenciesName'] == null ? undefined : json['currenciesName'],
    currenciesNumber:
      json['currenciesNumber'] == null ? undefined : json['currenciesNumber'],
    currenciesRatio:
      json['currenciesRatio'] == null ? undefined : json['currenciesRatio'],
    currenciesTitle:
      json['currenciesTitle'] == null ? undefined : json['currenciesTitle'],
  }
}

export function GetProductsAsGroupName200ResponseDataInnerToJSON(
  value?: GetProductsAsGroupName200ResponseDataInner | null
): any {
  if (value == null) {
    return value
  }
  return {
    id: value['id'],
    name: value['name'],
    title: value['title'],
    description: value['description'],
    data: GetProductsAsGroupName200ResponseDataInnerDataToJSON(value['data']),
    price: value['price'],
    finalPrice: value['finalPrice'],
    currenciesName: value['currenciesName'],
    currenciesNumber: value['currenciesNumber'],
    currenciesRatio: value['currenciesRatio'],
    currenciesTitle: value['currenciesTitle'],
  }
}
